import RoutedSavableApp from 'platform/forms/save-in-progress/RoutedSavableApp';
import { useBrowserMonitoring } from 'platform/monitoring/Datadog';
import { DowntimeNotification } from 'platform/monitoring/DowntimeNotification';
import {
  healthAppsBeforeSend,
  selectIsAppLoading,
} from 'platform/shared/health-apps';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import formConfig from '../config/form';
import { useDefaultFormData } from '../hooks/useDefaultFormData';
import { useLoa3UserData } from '../hooks/useLoa3UserData';
import content from '../locales/en/content.json';
import manifest from '../manifest.json';
import { FORM_TOGGLES } from '../utils/constants';

const BROWSER_MONITORING_PROPS = {
  service: manifest.datadog.service,
  beforeSend: healthAppsBeforeSend,
};

const App = ({ children, location }) => {
  const isAppLoading = useSelector(selectIsAppLoading);

  useLoa3UserData();
  useDefaultFormData(FORM_TOGGLES);
  useBrowserMonitoring(BROWSER_MONITORING_PROPS);

  return isAppLoading ? (
    <va-loading-indicator
      message={content['load-app']}
      class="vads-u-margin-y--4"
      set-focus
    />
  ) : (
    <RoutedSavableApp formConfig={formConfig} currentLocation={location}>
      <DowntimeNotification
        appTitle={formConfig.subTitle}
        dependencies={formConfig.downtime.dependencies}
      >
        {children}
      </DowntimeNotification>
    </RoutedSavableApp>
  );
};

App.propTypes = {
  location: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default App;
